<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>file_download</mat-icon></div>
    <div class="cds-header-text">
      <h2 class="cf-dlg-title">Exportar ventas a Excel</h2>
      <p class="cf-dlg-subtitle">Selecciona el rango de fechas del informe</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" type="button" (click)="cerrar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="generarExcel()" novalidate>
    <div class="cf-dlg-body">
      <span class="cf-dlg-section__label">Periodo</span>

      <div class="cf-dlg-row">
        <app-date [control]="form.controls.desde" [config]="desdeConfig"></app-date>
        <app-date [control]="form.controls.hasta" [config]="hastaConfig"></app-date>
      </div>

      <p class="cds-error" *ngIf="form.hasError('rangoInvalido')">
        La fecha 'Desde' no puede ser posterior a la fecha 'Hasta'.
      </p>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" type="button" (click)="cerrar()">
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button mat-flat-button class="cf-dlg-btn-primary" type="submit" [disabled]="form.invalid">
        <mat-icon>file_download</mat-icon> Generar Excel
      </button>
    </div>
  </form>
</div>
